const sorBaseUrl = (organizationId: number): string =>
  `/sysconfig/api/v1/organizations/${organizationId}/system_of_record`;

export const sorConfigurationUrl = (organizationId: number): string => `${sorBaseUrl(organizationId)}/config`;

export const sorTestConnectionUrl = (organizationId: number): string =>
  `${sorConfigurationUrl(organizationId)}/test_connection`;

export const sorOperationsUrl = (organizationId: number): string => `${sorBaseUrl(organizationId)}/operations`;

export const sorOpenAttemptCountsUrl = (organizationId: number): string =>
  `${sorBaseUrl(organizationId)}/attempts/open_counts`;

export const sorIssueIdsUrl = (organizationId: number): string => `${sorBaseUrl(organizationId)}/attempts/item_ids`;

export const sorIssuesByIdsUrl = (organizationId: number): string =>
  `${sorBaseUrl(organizationId)}/attempts/items_by_ids`;

export const sorIssueOperationsUrl = (organizationId: number): string =>
  `${sorBaseUrl(organizationId)}/attempts/operations`;

export const sorResolveAttemptUrl = (organizationId: number, attemptId: number): string =>
  `${sorBaseUrl(organizationId)}/attempts/${attemptId}/resolve`;

export const sorReconcileUrl = (organizationId: number): string => `${sorBaseUrl(organizationId)}/reconcile`;
